import React from 'react';
import { Link } from 'react-router-dom';
import './Products.css';
import productsData from '../data/products.json';
import ProductCard from '../Components/ProductCard';

function Products() {
  const { header, products } = productsData;

  return (
    <div className="products-page">
      {/* Page Header */}
      <section className="page-header">
        
        <div className="container">
          <h1>{header.title}</h1>
          <p>{header.subtitle}</p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="section bg-light">
        <div className="container">
          <div className="products-catalog-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>

      {/* Custom Solution Callout */}
      <section className="section">
        <div className="container custom-solution text-center">
          <h2>Need a specific component not listed here?</h2>
          <p>We source specialized fire safety and engineering equipment globally. Let us know what you need.</p>
          <Link to="/contact" className="btn btn-primary mt-1">Contact Sourcing Team</Link>
        </div>
      </section>
    </div>
  );
}

export default Products;